import React from 'react';
import { AppBar, Toolbar, Button, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLanguage } from 'Context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { ENDPOINTS } from '../../core/constants/pageEndpoints.constants';
import LogoLight from '@assets/icons/logo-login-icon.svg';
import LogoDark from '@assets/icons/logo-login-icon-light.svg';

const LoggedOutMenu = () => {
  const navigate = useNavigate();
  const lan = useLanguage();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const logoSrc = isDarkMode ? LogoDark : LogoLight;
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        paddingY: 1,
        px: 2,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Toolbar disableGutters sx={{ width: '100%' }}>
        {/* Brand / Logo */}
        <Box
          component="a"
          href="https://www.appfielder.com"
          aria-label="AppFielder home"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <Box
            component="img"
            src={logoSrc}
            alt="AppFielder"
            sx={{
              height: 42,
              width: 'auto',
              userSelect: 'none',
            }}
          />
        </Box>

        {/* Right side (Login) */}
        <Button
          id="navbar-login-button"
          onClick={() => navigate(ENDPOINTS.login)}
          sx={{
            ml: 'auto',
            textTransform: 'none',
            fontSize: 16,
            fontWeight: 600,
            color: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          {lan.getInto}
        </Button>
      </Toolbar>
    </AppBar>
  );
};
export default LoggedOutMenu;
//Original code:
/*import React from 'react';
import Logo from '@assets/icons/logo-login-icon.svg';
import { Toolbar, Button, Box } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { ENDPOINTS } from '../../core/constants/pageEndpoints.constants';
const LoggedOutMenu = () => {
	const navigate = useNavigate();
	const lan = useLanguage();
	return (
    <AppBar position="fixed" elevation={0} sx={{ backgroundColor: 'white', p: 1 }}>
      <Toolbar disableGutters sx={{ px: 2 }}>
<Box
  component="a"
  href="https://www.appfielder.com"
  aria-label="AppFielder home"
  sx={{ display: 'inline-flex', alignItems: 'center' }}
>
  <LogoImage src={Logo} alt="AppFielder" />
</Box>
<Button
  id="navbar-login-button"
  onClick={() => navigate(ENDPOINTS.login)}
  sx={{ ml: 'auto', textTransform: 'none', fontWeight: 600 }}
>
  {lan.getInto}
</Button>
</Toolbar>
</AppBar>
);
};

export default LoggedOutMenu;
*/
